import { AnchoredLayerPosition } from '@doordash/component-layer-manager';
export { IconType as ToastIconType, InsetSize as ToastInsetSize } from '@doordash/design-language';

var _ToastPositionAlignme;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var buttonOverridesFromTheme = function buttonOverridesFromTheme(theme) {
  return {
    Colors: {
      ButtonFlatPrimaryForeground: theme.Colors.ToastInformationalAction,
      ButtonFlatPrimaryForegroundDisabled: theme.Colors.ToastInformationalActionDisabled,
      ButtonFlatPrimaryForegroundHovered: theme.Colors.ToastInformationalActionHovered,
      ButtonFlatPrimaryForegroundPressed: theme.Colors.ToastInformationalActionPressed
    },
    Typography: {
      TextStyles: {
        ToastAction: theme.Typography.TextStyles.ToastAction
      }
    }
  };
};
var ToastPosition = {
  TopStart: AnchoredLayerPosition.TopLeft,
  TopCenter: AnchoredLayerPosition.TopCenter,
  TopEnd: AnchoredLayerPosition.TopRight,
  BottomStart: AnchoredLayerPosition.BottomLeft,
  BottomCenter: AnchoredLayerPosition.BottomCenter,
  BottomEnd: AnchoredLayerPosition.BottomRight
};
var ToastPositionAlignment = (_ToastPositionAlignme = {}, _defineProperty(_ToastPositionAlignme, ToastPosition.BottomCenter, 'center'), _defineProperty(_ToastPositionAlignme, ToastPosition.TopCenter, 'center'), _defineProperty(_ToastPositionAlignme, ToastPosition.BottomStart, 'flex-start'), _defineProperty(_ToastPositionAlignme, ToastPosition.TopStart, 'flex-start'), _defineProperty(_ToastPositionAlignme, ToastPosition.BottomEnd, 'flex-end'), _defineProperty(_ToastPositionAlignme, ToastPosition.TopEnd, 'flex-end'), _ToastPositionAlignme);

export { ToastPosition, ToastPositionAlignment, buttonOverridesFromTheme };
